import { InstallAppMenuItem } from '@/components/pwa/InstallAppButton';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/hooks/use-auth';
import { getApiErrorMessage } from '@/lib/api/error';
import { ChevronDown, LogOut, UserCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { UserIdentityBadge } from './UserIdentityBadge';

export function UserMenu() {
  const { user, logout: authLogout } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await authLogout();
      navigate('/login');
    } catch (error) {
      toast.error('Erro ao sair da sessão', {
        description: getApiErrorMessage(error, 'Tente novamente em instantes.'),
      });
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-auto min-w-0 gap-2 rounded-xl px-2 py-1.5 sm:px-3"
          aria-label="Abrir menu do usuário"
        >
          <UserIdentityBadge
            name={user?.name}
            subtitle={user?.socialNumber}
            photoUrl={user?.photo}
            className="[&>div:first-child]:h-9 [&>div:first-child]:w-9 [&>div:last-child]:hidden md:[&>div:last-child]:block"
          />
          <ChevronDown className="text-muted-foreground hidden h-4 w-4 shrink-0 sm:block" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <div className="px-2 py-1.5 md:hidden">
          <p className="truncate text-sm font-semibold">{user?.name}</p>
          {user?.socialNumber ? <p className="text-muted-foreground truncate text-xs">{user.socialNumber}</p> : null}
        </div>
        <DropdownMenuSeparator className="md:hidden" />
        <DropdownMenuItem className="cursor-pointer" onClick={() => navigate('/profile')}>
          <UserCircle2 className="mr-2 h-4 w-4" />
          Meu perfil
        </DropdownMenuItem>
        <InstallAppMenuItem />
        <DropdownMenuSeparator />
        <DropdownMenuItem className="text-destructive cursor-pointer" onClick={() => void logout()}>
          <LogOut className="mr-2 h-4 w-4" />
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
